const initailState = "6mk8d4ZaH7gmle9CiXei";

const activeCelebId = (state = initailState, action) => {
  switch (action.type) {
    case "UPDATE_ACTIVE_CELEB_ID":
      return action.value;
    default:
      return state;
  }
};

export default activeCelebId;
